import { render, staticRenderFns } from "./AddNoteButton.vue?vue&type=template&id=fd986c4e"
import script from "./AddNoteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNoteButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports